import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { URL_CONST } from 'utils/urlConsts'

import { selectBrand, selectSelfFeatureFlags } from 'containers/App/selectors'

const Wrapper = styled.div`
  padding: 8px 12px 10px;
`

const Label = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`

const PortalLink = styled.a`
  display: inline-block;
  font-size: 13px;
  color: var(--primary);
  white-space: normal;

  &:hover {
    text-decoration: underline;
  }
`

const Divider = styled.div`
  border-bottom: 1px solid var(--color-border);
  margin: 0 4px;
`

export function OpenPortalLink() {
  const brand = useSelector(selectBrand)
  const featureFlags = useSelector(selectSelfFeatureFlags)

  if (!brand || !featureFlags?.ENABLE_MSP_WEBPORTAL_FF) return null

  return (
    <>
      <Wrapper>
        <Label>Partner Portal (BETA)</Label>
        <PortalLink
          href={URL_CONST.mspPortal.self}
          target="_blank"
          rel="noopener noreferrer"
          data-pendo-feature="msp-portal-link"
        >
          Open Partner Portal
        </PortalLink>
      </Wrapper>
      <Divider />
    </>
  )
}

export default OpenPortalLink
